import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

const data = [
    { month: 'Jan', budget: 2.1, real: 2.0 },
    { month: 'Fév', budget: 2.0, real: 2.2 },
    { month: 'Mar', budget: 2.3, real: 2.1 },
    { month: 'Avr', budget: 2.2, real: 2.4 },
    { month: 'Mai', budget: 2.5, real: 2.3 },
    { month: 'Juin', budget: 2.4, real: 2.6 },
    { month: 'Juil', budget: 2.7, real: 2.5 },
    { month: 'Août', budget: 2.6, real: 2.8 },
    { month: 'Sept', budget: 2.9, real: 2.7 },
    { month: 'Oct', budget: 2.8, real: 3.0 },
    { month: 'Nov', budget: 3.1, real: 2.9 },
    { month: 'Déc', budget: 3.0, real: 3.2 }
];

export default function BudgetTrackingChart() {
    return (
        <Card className="border-0 shadow-lg">
            <CardHeader>
                <CardTitle className="text-lg font-bold text-gray-900">
                    Suivi Budgétaire Mensuel
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="h-80">
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                            <XAxis
                                dataKey="month"
                                axisLine={false}
                                tickLine={false}
                                tick={{ fill: '#6b7280', fontSize: 12 }}
                            />
                            <YAxis
                                axisLine={false}
                                tickLine={false}
                                tick={{ fill: '#6b7280', fontSize: 12 }}
                                tickFormatter={(value) => `${value}M€`}
                            />
                            <Tooltip
                                formatter={(value, name) => [`${value}M€`, name === 'budget' ? 'Budget' : 'Réel']}
                                labelStyle={{ color: '#374151' }}
                                contentStyle={{
                                    backgroundColor: 'white',
                                    border: '1px solid #e5e7eb',
                                    borderRadius: '8px',
                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
                                }}
                            />
                            <Legend />
                            <Line
                                type="monotone"
                                dataKey="budget"
                                stroke="#2563eb"
                                strokeWidth={3}
                                dot={{ fill: '#2563eb', strokeWidth: 2, r: 6 }}
                                name="Budget"
                            />
                            <Line
                                type="monotone"
                                dataKey="real"
                                stroke="#16a34a"
                                strokeWidth={3}
                                dot={{ fill: '#16a34a', strokeWidth: 2, r: 6 }}
                                name="Réel"
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </CardContent>
        </Card>
    );
}